import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Analytics from "./components/Analytics";
import { ClerkLoading, SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";
import { Box, Button, Container, Typography } from "@mui/material";

function App() {
    return (
        <Box sx={{ flexGrow: 1 }}>
            {/* Neither SignedIn nor SignedOut renders until Clerk resolves, which used
                to look like a white page when Clerk was slow or blocked. */}
            <ClerkLoading>
                <Box sx={{ display: "flex", justifyContent: "center", height: "100vh", alignItems: "center" }}>
                    <Typography variant="body1" color="text.secondary">
                        Loading authentication...
                    </Typography>
                </Box>
            </ClerkLoading>

            <SignedOut>
                <Box sx={{ display: "flex", justifyContent: "center", height: "100vh", alignItems: "center" }}>
                    <Button variant="contained" sx={{ textTransform: "none", padding: "12px 24px", fontSize: "16px" }}>
                        <SignInButton asChild>
                            <span>Sign in</span>
                        </SignInButton>
                    </Button>
                </Box>
            </SignedOut>

            <SignedIn>
                <Container sx={{ mt: 4 }}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/analytics" element={<Analytics />} />
                    </Routes>
                </Container>
            </SignedIn>
        </Box>
    );
}

export default App;
